export interface VehicleIdentityData {
  id: string
  name?: string
  model?: string | { name?: string }
  modelName?: string
  brand?: { name?: string } | string
  brandName?: string
  year?: number
  modelYear?: number
  plate?: string
  identification?: { plate?: string }
  basic?: {
    name?: string
    model?: string | { name?: string }
    brand?: { name?: string } | string
    brandName?: string
    year?: number
    modelYear?: number
    plate?: string
    salePrice?: number | string
    price?: number | string
    mileage?: number
    photoUrl?: string
    imageUrl?: string
  }
  catalog?: {
    modelYear?: number
    brand?: { name?: string }
    model?: { name?: string }
  }
  photos?: { url?: string }[]
  images?: string[]
  salePrice?: number | string
  price?: number | string
  mileage?: number
  specifications?: { mileage?: number }
  pricing?: {
    sale?: {
      finalPrice?: number | string | { amount?: number | string; value?: number | string }
      announcedPrice?: number | string | { amount?: number | string; value?: number | string }
      salePrice?: number | string | { amount?: number | string; value?: number | string }
    }
  }
  media?: {
    photos?: Array<Record<string, unknown>>
  }
}

const asObject = (value: unknown): Record<string, unknown> | null =>
  value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : null

export const normalizeVehicleIdentity = (raw: unknown): VehicleIdentityData => {
  const base = asObject(raw) ?? {}
  const nestedData = asObject(base.data)
  const source = nestedData ?? base
  const basic = asObject(source.basic)
  const id = String(source.id ?? basic?.id ?? '')

  const media = asObject(source.media)
  const mediaPhotos = Array.isArray(media?.photos)
    ? (media.photos as Array<Record<string, unknown>>)
        .map((item) => {
          const current = asObject(item)
          const url = current?.url ?? current?.thumbnail ?? current?.path
          return { url: typeof url === 'string' ? url : undefined }
        })
        .filter((item) => Boolean(item.url))
    : []

  const photos = Array.isArray(source.photos)
    ? (source.photos as Array<{ url?: string }>)
    : Array.isArray(basic?.photos)
      ? (basic.photos as Array<{ url?: string }>)
      : mediaPhotos

  const images = Array.isArray(source.images)
    ? (source.images as string[])
    : Array.isArray(basic?.images)
      ? (basic.images as string[])
      : []

  return {
    ...(source as unknown as Partial<VehicleIdentityData>),
    id,
    basic: basic ? (basic as VehicleIdentityData['basic']) : (source.basic as VehicleIdentityData['basic']),
    photos,
    images,
  }
}

export const normalizeVehicleIdentityList = (items: unknown[]): VehicleIdentityData[] =>
  items.map(normalizeVehicleIdentity).filter((vehicle) => vehicle.id.length > 0)

